export default __webpack_public_path__ + "static/media/MAQUINADOINDPRENSAS.b872bedb.webp";